var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApplicationRef } from '@angular/core';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { ResponseService } from './response/response.service';
import { filter, delay, take } from 'rxjs/operators';
import { HasSubscriptions } from '../components/has-subscriptions';
/**
 * The purpose of this service is solely for server rendering purposes for SEO.
 * This service will set the window.prerenderready=true to notify the server rendering that the page is ready to displayed, so we don't have to wait for every call to finish before displaying the page
 * All top level routes will have this service
 *
 */
var PreRenderService = /** @class */ (function (_super) {
    __extends(PreRenderService, _super);
    function PreRenderService(platformId, appRef, responseService) {
        var _this = _super.call(this) || this;
        _this.platformId = platformId;
        _this.appRef = appRef;
        _this.responseService = responseService;
        if (isPlatformBrowser(_this.platformId)) {
            _this.addSub(appRef.isStable.pipe(filter(function (stable) { return stable; }), delay(3000), take(1))
                .subscribe(function () {
                _this.onAppStable();
            }));
        }
        return _this;
    }
    Object.defineProperty(PreRenderService.prototype, "isServerMode", {
        get: function () {
            return isPlatformServer(this.platformId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PreRenderService.prototype, "isBrowserMode", {
        get: function () {
            return isPlatformBrowser(this.platformId);
        },
        enumerable: true,
        configurable: true
    });
    PreRenderService.prototype.onAppStable = function () {
        if (this.isServerMode) {
            return;
        }
        // const dom = getDOM();
        var styles = Array.prototype.slice.apply(document.querySelectorAll("style[ng-transition-rmx]"));
        styles.filter(function (el) { return el.getAttribute('ng-transition-rmx') === 'remaxdotca'; })
            .forEach(function (el) { return el.remove(); });
    };
    /**
     * Sets the window.prerenderready=true for server rendering purposes
     * @param statusCode HTTP status code
     * @param redirectUrl the url for the location header
     * @param paramString the query params string (no question mark included)
     */
    PreRenderService.prototype.setPreRenderFlag = function (statusCode, redirectUrl, params) {
        // this.setResponseCode(statusCode, redirectUrl);
        if (!this.isServerMode) {
            return;
        }
        this.responseService.setResponseCode('' + statusCode, redirectUrl, params);
    };
    return PreRenderService;
}(HasSubscriptions));
export { PreRenderService };
